import React from "react";
import styled from "styled-components";
import {ReactComponent as DetailIcon} from "../../images/ico_link.svg";

function LV1Table(props){
    const tableHeader = props.tableHeader;
    const tableData = props.tableData;
    const codeNumber = props.codeNumber;

    return(
        <>
            <TableWrap>
                <CustomTable>
                    <colgroup>
                        <col style={{width: '*'}} />
                        <col style={{width: '80%'}} />
                    </colgroup>
                    <thead>
                        <tr>
                            {tableHeader && tableHeader.map(headerItem => (
                                <HeadCell>{headerItem}</HeadCell>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                    {tableData && tableData.map(item => (
                        <tr>
                            <BodyCell style={{cursor: "pointer", textAlign: "center"}}>
                                <a
                                    href={"/detailHS?HS=" + item.code + "&codeNumber=" + codeNumber}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        color: "black"
                                    }}
                                >
                                    {item.code}
                                    <DetailIcon style={{width: '10px', marginLeft: '3px', cursor: "pointer"}}/>
                                </a>
                            </BodyCell>
                            <BodyCell>{item.def_kr}</BodyCell>
                        </tr>
                        ))}
                    </tbody>
                </CustomTable>
            </TableWrap>
        </>
)
}

export default LV1Table;

const TableWrap = styled.div`
    display: flex;
    justify-content: center;
    padding: 0px 0px 5px 0px;
    width: 100%;
`;

const CustomTable = styled.table`
    table-layout: auto;
    width: 100%;`;

const HeadCell = styled.th`
    border-top: 2px solid #585858;
    border-spacing: 0;
    padding: 12px 10px 10px 10px;
    background-color: #dfdfdf;
    text-align: center;
    letter-spacing: 1px;
    table-layout: auto;
`;
const BodyCell = styled.td`
    padding: 13px;
    border-bottom: 2px solid rgba(49,49,49, 0.2);
    letter-spacing: 1px;
    line-height: 1.2;
    table-layout: auto;
`;
